"use strict";
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateObjects = void 0;
/**
 *
 * Aggregates multiple objects into a single object by combining values of matching keys.
 * For each key present in any of the input objects, creates a comma-separated string
 * of values from all objects.
 * @param param - the objects to aggregate and the aggregation method
 * @returns a single object containing all unique keys with aggregated values
 * @example
 * const obj1 = { name: 'John', age: 30 };
 * const obj2 = { name: 'Jane', city: 'NY' };
 * const obj3 = { name: 'Bob', age: 25 };
 *
 * // Without wrap
 * aggregateObjects({ objs: [obj1, obj2, obj3] })
 * // Returns: { name: 'John,Jane,Bob', age: '30,,25', city: ',NY,' }
 *
 * // With wrap
 * aggregateObjects({ objs: [obj1, obj2, obj3], wrap: true })
 * // Returns: { name: '[John],[Jane],[Bob]', age: '[30],[],[25]', city: '[],[NY],[]' }
 */
const aggregateObjects = ({ objs, wrap = false, }) => {
    const allKeys = Array.from(new Set(objs.flatMap((a) => (a && typeof a === 'object' ? Object.keys(a) : []))));
    // Reduce into a single object, where each key contains concatenated values from all input objects
    return allKeys.reduce((acc, key) => {
        const values = objs
            .map((o) => { var _a, _b; return (wrap ? `[${(_a = o === null || o === void 0 ? void 0 : o[key]) !== null && _a !== void 0 ? _a : ''}]` : (_b = o === null || o === void 0 ? void 0 : o[key]) !== null && _b !== void 0 ? _b : ''); })
            .join(',');
        acc[key] = values;
        return acc;
    }, {});
};
exports.aggregateObjects = aggregateObjects;
//# sourceMappingURL=aggregateObjects.js.map